import React from 'react';
import StyledDataGridToolbar from '@/components/datagrid/StyledDataGridToolbar';
import { useTranslation } from 'react-i18next';

const SensorDataGridToolbar = ({ ...props }) => {
  const { t } = useTranslation('translation');

  return (
    <StyledDataGridToolbar
      placeholder="Sensors"
      buttonTitle={t('translation:new')}
      dialogTitle="Add New Sensor"
      {...props}
    />
  );
};

export default SensorDataGridToolbar;
